import {
  ColorsPrimary100,
  Dimensions2,
  Dimensions4,
  Dimensions6,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const contentItem = css({
  '&.MuiBox-root': {
    backgroundColor: ColorsPrimary100,
    padding: `${Dimensions6} ${Dimensions4}`,
    margin: `${Dimensions6} 0`,

    '&:last-child': {
      paddingBottom: '0',
    },
  },
});

const contentItemRow = css({
  '&.MuiBox-root': {
    display: 'flex',
    padding: `${Dimensions2} 0`,

    '& .MuiTypography-caption': {
      width: '60%',
    },

    '& .MuiTypography-body2': {
      fontWeight: 'bold',
      width: '40%',
      textAlign: 'center',
    },

    '@media (max-width: 600px)': {
      flexDirection: 'column',
      gap: Dimensions4,

      '& .MuiTypography-caption': {
        width: '100%',
      },

      '& .MuiTypography-body2': {
        width: '100%',
        textAlign: 'left',
        paddingLeft: Dimensions4,
      },
    },
  },
});

const snackWrapper = css({
  '&.MuiSnackbar-root': {
    '.MuiPaper-root': {
      '.MuiAlert-action': {
        paddingTop: 0,
      },
    },
  },
});

const buttonWrapper = css({
  '&.MuiBox-root': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: Dimensions6,
  },
});

const ActionModalStyles = {
  contentItem,
  contentItemRow,
  snackWrapper,
  buttonWrapper,
};

export default ActionModalStyles;
